import { Capacitor } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'

// Inits some settings as app loads for mobile app
const init = (): void => {
  if (!Capacitor.isNativePlatform()) return
  // In capacitor, make sure that the keyboard accessory bar is visible
  Keyboard.setAccessoryBarVisible({ isVisible: true })
}

export default { init }
